import React, { useState } from 'react';
import { ChevronDown, FileText } from 'lucide-react';

// Common math templates
const TEMPLATES = [
  {
    name: 'Quadratic Formula',
    latex: 'x = \\frac{-b \\pm \\sqrt{b^2-4ac}}{2a}',
    category: 'Algebra'
  },
  {
    name: 'Pythagorean Theorem',
    latex: 'a^2 + b^2 = c^2',
    category: 'Geometry'
  },
  {
    name: 'Slope-Intercept Form',
    latex: 'y = mx + b',
    category: 'Algebra'
  },
  {
    name: 'Point-Slope Form',
    latex: 'y - y_1 = m(x - x_1)',
    category: 'Algebra'
  },
  {
    name: 'Derivative Definition',
    latex: "f'(x) = \\lim_{h \\to 0} \\frac{f(x+h) - f(x)}{h}",
    category: 'Calculus'
  },
  {
    name: 'Basic Derivative',
    latex: '\\frac{d}{dx}f(x)',
    category: 'Calculus'
  },
  {
    name: 'Definite Integral',
    latex: '\\int_{a}^{b} f(x)\\,dx',
    category: 'Calculus'
  },
  {
    name: 'Indefinite Integral',
    latex: '\\int f(x)\\,dx = F(x) + C',
    category: 'Calculus'
  },
  {
    name: 'Summation',
    latex: '\\sum_{i=1}^{n} x_i',
    category: 'Series'
  },
  {
    name: 'Limit',
    latex: '\\lim_{x \\to \\infty} f(x)',
    category: 'Calculus'
  },
  {
    name: 'Area of Circle',
    latex: 'A = \\pi r^2',
    category: 'Geometry'
  },
  {
    name: 'Circumference',
    latex: 'C = 2\\pi r',
    category: 'Geometry'
  },
  {
    name: 'Distance Formula',
    latex: 'd = \\sqrt{(x_2-x_1)^2 + (y_2-y_1)^2}',
    category: 'Geometry'
  },
  {
    name: 'Midpoint Formula',
    latex: 'M = \\left(\\frac{x_1+x_2}{2}, \\frac{y_1+y_2}{2}\\right)',
    category: 'Geometry'
  },
  {
    name: '2x2 Matrix',
    latex: '\\begin{pmatrix} a & b \\\\ c & d \\end{pmatrix}',
    category: 'Linear Algebra'
  },
  {
    name: '3x3 Matrix',
    latex: '\\begin{pmatrix} a & b & c \\\\ d & e & f \\\\ g & h & i \\end{pmatrix}',
    category: 'Linear Algebra'
  },
  {
    name: 'Binomial Theorem',
    latex: '(a+b)^n = \\sum_{k=0}^{n} \\binom{n}{k} a^{n-k} b^k',
    category: 'Algebra'
  },
  {
    name: 'Law of Sines',
    latex: '\\frac{a}{\\sin A} = \\frac{b}{\\sin B} = \\frac{c}{\\sin C}',
    category: 'Trigonometry'
  },
  {
    name: 'Law of Cosines',
    latex: 'c^2 = a^2 + b^2 - 2ab\\cos C',
    category: 'Trigonometry'
  },
  {
    name: 'Euler\'s Formula',
    latex: 'e^{i\\theta} = \\cos\\theta + i\\sin\\theta',
    category: 'Complex'
  }
];

const MathTemplates = ({ onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (template) => {
    if (onSelect) {
      onSelect(template.latex);
    }
    setIsOpen(false);
  };

  return (
    <div className="wb-templates-container" style={{ position: 'relative' }}>
      <button
        className="wb-templates-btn"
        onClick={() => setIsOpen(!isOpen)}
      >
        <FileText size={14} />
        Templates
        <ChevronDown size={14} />
      </button>

      {isOpen && (
        <div className="wb-templates-dropdown">
          {TEMPLATES.map((template, index) => (
            <button
              key={index}
              className="wb-template-item"
              onClick={() => handleSelect(template)}
            >
              <div className="wb-template-name">{template.name}</div>
              <div className="wb-template-preview">{template.latex.substring(0, 40)}...</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default MathTemplates;
